'use client';

import { cn, getColorwayWithTransparency, getYMargins } from '@/utils/styles';
import CardsVerticalScrollItemMobile from './CardsVerticalScrollMobileItem';
import { CardsVerticalScrollProps } from './types';
import { Colorways } from '@/types/constants';
import { useVerticalScroll } from './useCardsVerticalScrollMobile';
import { DEFAULT_MAX_MOBILE_CARD_HEIGHT } from './constants';

const CardsVerticalScroll = ({
  sectionName,
  margins,
  transparentBackground,
  copyAlignment,
  cards,
}: CardsVerticalScrollProps) => {
  const cardCount = cards?.items?.length ?? 0;
  const {
    containerRef,
    viewportRef,
    handleNavScroll,
    maxMobileCardHeight,
    cardTops,
    expandedStates,
    trackHeight,
    stickyOffset,
  } = useVerticalScroll(cardCount);

  const internalClassNames = {
    wrapper: cn('relative sm:block sm:overflow-visible', getYMargins(margins), 'py-0'),
    track: cn(
      'relative w-full rounded-3xl',
      getColorwayWithTransparency(Colorways.DarkGreenGradientLeftToRight, transparentBackground),
    ),
    viewport: cn('sticky w-full'),
    cards: cn('relative w-full'),
  };

  const viewportHeight = maxMobileCardHeight ?? DEFAULT_MAX_MOBILE_CARD_HEIGHT;

  return (
    <div
      ref={containerRef}
      id={sectionName}
      data-testid="mobile-version"
      className={internalClassNames.wrapper}
      style={{ minHeight: trackHeight || viewportHeight }}>
      <div className={internalClassNames.track} style={{ height: trackHeight || viewportHeight }}>
        <div
          ref={viewportRef}
          className={internalClassNames.viewport}
          style={{ top: stickyOffset, height: viewportHeight }}>
          <div className={internalClassNames.cards} style={{ height: viewportHeight }}>
            {cards?.items?.map((card, index) => (
              <CardsVerticalScrollItemMobile
                key={`${card.sys.id}-${index}`}
                {...card}
                copyAlignment={copyAlignment}
                index={index}
                cardCount={cardCount}
                isExpanded={expandedStates[index]}
                onExpand={() => handleNavScroll(index)}
                cardTop={cardTops[index]}
                maxMobileCardHeight={viewportHeight}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardsVerticalScroll;
